import React, { ReactNode } from 'react';
import { Box, Split } from '@dropbox/dig-foundations';
import { WhiteLabelThemeProvider } from 'signer-app/white-labeling/theme-provider';
import styles from 'signer-app/signer-experience/signer-toolbar/signer-toolbar.module.css';
import ToolbarZoomControls from 'signer-app/parts/toolbar-zoom-controls';
import { ContinueButton } from '../action-buttons/continue-button';

export function DrawerToolbar({
  toolbarMenu,
  mobileToggle,
}: {
  toolbarMenu: ReactNode;
  mobileToggle: ReactNode;
}) {
  return (
    <WhiteLabelThemeProvider mode="bright">
      <Box
        paddingX="Micro Small"
        paddingY={'Micro Small'}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="Background Subtle"
        className={styles.drawerToolbar}
        columnGap="Micro Small"
      >
        {toolbarMenu}
        {mobileToggle}

        <Box marginLeft={'auto'}></Box>

        <Split gap="Micro Large" alignY="center">
          <Split.Item>
            <ToolbarZoomControls />
          </Split.Item>
          <Split.Item>
            <ContinueButton />
          </Split.Item>
        </Split>
      </Box>
    </WhiteLabelThemeProvider>
  );
}
